import React, { useState, useEffect, useMemo, useRef } from 'react'
import { ContentHeader, Loader } from '@components';
import { TableHeader, Pagination, Search } from '@app/components/react-data-table';
import moment from 'moment';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getApiLog } from '../../services/api_log';
import { getPortals } from '../../services/portal';
import ReactToPrint from 'react-to-print';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom'

const ApiLog = () => {
    const componentRef = useRef();
    const [listData, setListData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [sorting, setSorting] = useState({ field: "", order: "" });
    const ITEMS_PER_PAGE = 25;
    const [portalData, setPortalData] = useState([]);

    const colomns = [
        { name: "Portal Name", field: "portal_name", sortable: false },
        { name: "Type", field: "type", sortable: false },
        { name: "Title", field: "title", sortable: false },
        { name: "URL", field: "url", sortable: false },
        { name: "Created", field: "created_at", sortable: false },
        { name: "Action", field: "", sortable: false, className: 'td-center d-print-none' }
    ];

    const [filterData, setFilterData] = useState({ 'from': '', 'to': '', 'portal_id': '' });

    const resultData = useMemo(() => {
        let computedResults = listData;
        if (search) {
            computedResults = computedResults.filter(
                data => data.title.toLowerCase().includes(search.toLowerCase()) || data.type.toLowerCase().includes(search.toLowerCase()) || data.url.toLowerCase().includes(search.toLowerCase()));
        }
        setTotalItems(computedResults.length);
        //Sorting listData
        if (sorting.field) {
            const reversed = sorting.order === "asc" ? 1 : -1;
            computedResults = computedResults.sort(
                (a, b) =>
                    reversed * a[sorting.field].localeCompare(b[sorting.field])
            );
        }
        //Current Page slice
        return computedResults.slice(
            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
        );
    }, [listData, currentPage, search, sorting]);


    useEffect(() => {
        setSearch("");
        getList();
        getPostalList();
    }, [])


    const applyFilter = (selectopt: any, type: any) => {
        let data = { ...filterData };
        data[type] = (type == 'from' || type == 'to') ? moment(selectopt).format('MM/DD/YYYY') : selectopt.target.value;
        setFilterData(data);
    }

    const getList = (filter = "") => {
        setLoading(true);
        getApiLog(filter).then(function (res) {
            const resp = res.data;
            if (resp.Acknowledge == 1 && resp.apiLogs) {
                let data: any = [];
                resp.apiLogs.map((val: any, i: any) => {
                    data[i] = {
                        id: val.id,
                        portal_id: val.portal_id,
                        portal_name: val.portal_name,
                        type: val.type,
                        title: val.title,
                        url: val.url,
                        created_at: val.created_at ? moment(val.created_at).format('MM/DD/YYYY HH:mm') : ''
                    };
                });
                setListData(data);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            return false;
        });
    };


    const getPostalList = (filter = "") => {
        setLoading(true);
        getPortals(filter).then(function (res) {
            const resp = res.data;
            if (resp.Acknowledge == 1 && resp.records) {
                let data: any = [];
                resp.records.map((val: any, i: any) => {
                    data[i] = {
                        id: val.id,
                        name: val.name
                    };
                });
                setPortalData(data);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            return false;
        });
    };

    return (
        <>
            <ContentHeader title="Api Logs" />
            <section className="content">
                <div className="container-fluid">
                    <div className="col-12">
                        <div className='top_filter_blk row'>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className="form-group">
                                    <label>Portal</label>
                                    <select className="form-control" onChange={(e) => applyFilter(e, "portal_id")}>
                                        <option value="">Select Portal</option>
                                        {portalData.map((row) => (
                                            <option value={row.id}>{row.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className="form-group">
                                    <label>Type</label>
                                    <select className="form-control" onChange={(e) => applyFilter(e, "type")}>
                                        <option value="">Select Type</option>
                                        <option value="Error">Erorr</option>
                                        <option value="Debug">Debug</option>
                                        <option value="Info">Info</option>
                                    </select>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-xl-2'>
                                <div className="form-group">
                                    <label>From Date</label>
                                    <DatePicker dropdownMode="select" adjustDateOnChange showMonthDropdown showYearDropdown autoComplete='off' onChange={(e) => applyFilter(e, "from")} value={filterData['from'] ? filterData['from'] : ''} placeholderText="mm/dd/yyyy" className="form-control float-right datepicker" />
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-xl-2'>
                                <div className="form-group">
                                    <label>To Date</label>
                                    <DatePicker dropdownMode="select" adjustDateOnChange showMonthDropdown showYearDropdown autoComplete='off' onChange={(e) => applyFilter(e, "to")} value={filterData['to'] ? filterData['to'] : ''} placeholderText="mm/dd/yyyy" className="form-control float-right datepicker" />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <label>&nbsp;</label>
                                <div className="form-group">
                                    <button type="button" onClick={() => getList(filterData)} className="btn btn-primary">Search</button>
                                </div>
                            </div>
                        </div>

                        <div className="card order_listing future_delivery_listing">
                            <div className="card-body">
                                <div className='table-warp-search-pagination'>
                                    <div className='d-flex custom-pagination justify-content-between'>
                                        <Search
                                            onSearch={value => {
                                                setSearch(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                        <div className="dt-buttons btn-group flex-wrap mr-2 exp-btn">
                                            <ReactToPrint
                                                trigger={() => {
                                                    return <button className="btn btn-primary buttons-excel buttons-html5" type="button">
                                                        <span><i className="fas fa-print"></i> Print</span>
                                                    </button>;
                                                }}
                                                content={() => componentRef.current}
                                            />

                                        </div>
                                    </div>
                                    <div className='listing_table_wrap margin_table table-responsive' ref={componentRef}>
                                        <h3 className='d-none d-print-block m-2'>Contracted BBL Listing</h3>
                                        <table className="table table-bordered table-hover" style={{ width: '100%' }} >
                                            <TableHeader
                                                headers={colomns}
                                                onSorting={(field, order) =>
                                                    setSorting({ field, order })
                                                }
                                            />
                                            <tbody>
                                                {resultData.length > 0 ? resultData.map((row: any, podidx: number) => (
                                                    <tr className={row.type == 'Error' ? 'bg-red' : ''} key={podidx}>
                                                        <td className='td-left'>{row.portal_name}</td>
                                                        <td className='td-left'>{row.type}</td>
                                                        <td className='td-left'>{row.title}</td>
                                                        <td className='td-left'>{row.url}</td>
                                                        <td>{row.created_at}</td>
                                                        <td style={{ width: '10%', textAlign: 'center' }} className='d-print-none'>
                                                            <Link className="btn edit_btn p-0 pr-2" to={{ pathname: `/api-log/view/${row.id}` }} title="View"><i className="nav-icon far fa-eye"></i></Link>
                                                        </td>
                                                    </tr>
                                                ))
                                                    : <tr><td style={{ textAlign: 'center' }} colSpan="6">No record found.</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        total={totalItems}
                                        itemsPerPage={ITEMS_PER_PAGE}
                                        currentPage={currentPage}
                                        onPageChange={page => setCurrentPage(page)}
                                    />
                                </div>
                            </div>
                            <Loader isLoading={isLoading} />
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
};

export default ApiLog;
